var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.238 1.58765H8.74316V13.2562H15.238V1.58765Z",
    fill: "#FF5A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17534 7.42194C9.17534 5.05124 10.2898 2.94716 12 1.58767C10.7414 0.598078 9.15372 0 7.42194 0C3.31946 0 0 3.31946 0 7.42194C0 11.5244 3.31946 14.8439 7.42194 14.8439C9.15372 14.8439 10.7414 14.2458 12 13.2562C10.2874 11.9159 9.17534 9.79263 9.17534 7.42194Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.42194C24 11.5244 20.6805 14.8439 16.5781 14.8439C14.8463 14.8439 13.2586 14.2458 12 13.2562C13.7318 11.8943 14.8247 9.79263 14.8247 7.42194C14.8247 5.05124 13.7102 2.94716 12 1.58767C13.2562 0.598078 14.8439 0 16.5757 0C20.6805 0 24 3.34107 24 7.42194Z",
    fill: "#F79E1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.9843104012c9956ad599af96ba2dd3d1.svg";
export { ForwardRef as ReactComponent };